import { render, staticRenderFns } from "./discipline-summary-modal.vue?vue&type=template&id=50ea475c&scoped=true&"
import script from "./discipline-summary-modal.vue?vue&type=script&lang=js&"
export * from "./discipline-summary-modal.vue?vue&type=script&lang=js&"
import style0 from "./discipline-summary-modal.vue?vue&type=style&index=0&id=50ea475c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ea475c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50ea475c')) {
      api.createRecord('50ea475c', component.options)
    } else {
      api.reload('50ea475c', component.options)
    }
    module.hot.accept("./discipline-summary-modal.vue?vue&type=template&id=50ea475c&scoped=true&", function () {
      api.rerender('50ea475c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/modals/discipline-summary-modal.vue"
export default component.exports